import {GetSeferData} from "SeferPetach/GetData";

export async function getUserTag() {
    var payload = await GetSeferData("usf1", {});
    return (payload);
}
export async function updateUserTag(obj) {
    var args = {
            TAG_ID    : obj.TAG_ID,
            TAG_DESC  : obj.TAG_DESC,
            TAG_COLOR : obj.TAG_COLOR
    };
    var payload = await GetSeferData("usf2", args);
    return (payload);
}
export async function deleteUserTag(obj) {
    var payload = await GetSeferData("usf3", obj);
    return (payload);
}